import React, { useEffect, useState } from "react";
import { colors } from "@styles/cssinjs/helpers/variables";

export default function CarouselControls({ totalCarousels }) {
  const [itemVisible, setItemVisible] = useState(1);
  const [carouselElement, setCarouselElement] = useState<HTMLElement | null>(
    null
  );
  const itemsCount = totalCarousels - 1;

  const containerWidth = 1160;

  useEffect(() => {
    const initialOffset =
      window.innerWidth > containerWidth ? (window.innerWidth - 1160) / 2 : 0;
    const offset =
      window.innerWidth > containerWidth
        ? initialOffset - 400 * (itemVisible - 1)
        : initialOffset - 600 * (itemVisible - 1);
    if (carouselElement !== null) {
      translate(carouselElement, offset);
    }
  }, [itemVisible, carouselElement]);

  const translate = (element: HTMLElement, offset: number) => {
    element.style.transform = `translateX(${offset}px)`;
  };

  const moveRight = (e: React.MouseEvent<SVGElement>) => {
    if (carouselElement === null) {
      setCarouselElement(
        e.currentTarget
          .closest(".carousel-cont")!
          .querySelector(".carousel") as HTMLElement
      );
    }
    if (itemVisible < itemsCount) {
      setItemVisible(itemVisible + 1);
    } else {
      setItemVisible(itemVisible);
    }
  };

  const moveLeft = () => {
    setItemVisible(itemVisible - 1);
  };

  const LeftArrow = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        className={`pointer ${itemVisible <= 1 ? "disabled" : ""}`}
        onClick={() => {
          moveLeft();
        }}
      >
        <circle
          cx="20"
          cy="20"
          r="19.25"
          transform="rotate(-180 20 20)"
          stroke="#8996A3"
          strokeWidth="1.5"
        />
        <path
          d="M22.9289 27.0711L15.8579 20L22.9289 12.9289"
          stroke="#8996A3"
          strokeWidth="1.5"
        />
      </svg>
    );
  };

  const RightArrow = () => {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        width="40"
        height="40"
        viewBox="0 0 40 40"
        fill="none"
        className={`pointer ${itemVisible >= itemsCount ? "disabled" : ""}`}
        onClick={(e) => {
          moveRight(e);
        }}
      >
        <circle cx="20" cy="20" r="19.25" stroke="#8996A3" strokeWidth="1.5" />
        <path
          d="M17.0711 13.0002L24.1421 20.0713L17.0711 27.1424"
          stroke="#8996A3"
          strokeWidth="1.5"
        />
      </svg>
    );
  };
  const Dot = ({ order }) => {
    return (
      <>
        <span className={`${itemVisible === order ? "active" : ""}`}></span>
        <style jsx>{`
          span {
            width: 10px;
            height: 10px;
            border-radius: 50%;
            background-color: ${colors.primitive.grey[600]};
          }
          span.active {
            background-color: ${colors.primitive.grey[300]};
          }
        `}</style>
      </>
    );
  };

  const Dots = () => {
    return (
      <div className="fx pointer">
        {Array.from({ length: itemsCount }).map((_, count) => {
          const order = count + 1;
          return <Dot order={order} key={order} />;
        })}
        <style jsx>{`
          .fx {
            gap: 16px;
          }
        `}</style>
      </div>
    );
  };

  return (
    <div className="container text-center fx fx--ch fx--cv mt-10 md:d-none">
      <LeftArrow />
      <Dots />
      <RightArrow />
      <style jsx>{`
        .fx {
          gap: 110px;
        }
        :global(.disabled) {
          opacity: 0.15 !important;
          pointer-events: none;
        }
      `}</style>
    </div>
  );
}
